import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d1566e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMouseenter"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal ss-div-separador",
  role: "separator"
}, null, -1))
const _hoisted_6 = { class: "ss-span-descricao-card" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_fluxo = _resolveComponent("fluxo", true)!

  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_ctx.props.pontoInicial ? 'ss-fluxo': '')
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.cards, (card) => {
      return (_openBlock(), _createElementBlock("li", {
        key: card.identificador
      }, [
        _createElementVNode("div", {
          class: "ss-div-card ss-sombra-suave",
          onMouseenter: ($event: any) => (_ctx.selecaoCardAlterada(card.identificador))
        }, [
          _createElementVNode("div", {
            class: "ant-row ss-div-titulo-card",
            style: _normalizeStyle('border-color: ' + card.cor)
          }, [
            _createElementVNode("div", {
              class: "ant-col ant-col-xs-20 ant-col-xl-20",
              onClick: ($event: any) => (_ctx.editar(card.identificador))
            }, _toDisplayString(card.titulo), 9, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              (card.excluir && _ctx.props.editavel)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ant-btn ss-botao-excluir",
                    onClick: ($event: any) => (_ctx.excluir(card.identificador))
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_4))
                : _createCommentVNode("", true)
            ])
          ], 4),
          _hoisted_5,
          _createElementVNode("div", {
            class: "ss-div-descricao-card",
            style: _normalizeStyle('overflow-y: ' + (card.detalhes.length > 3 ? 'auto' : 'hidden'))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.detalhes, (detalhe, indexDetalhe) => {
              return (_openBlock(), _createElementBlock("div", {
                key: indexDetalhe,
                class: "ant-row"
              }, [
                (_ctx.UtilitarioGeral.valorValido(detalhe.icone))
                  ? (_openBlock(), _createBlock(_component_icone, {
                      key: 0,
                      nome: detalhe.icone
                    }, null, 8, ["nome"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_6, _toDisplayString(detalhe.texto), 1)
              ]))
            }), 128))
          ], 4),
          (card.incluirFilho && _ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ant-btn ant-btn-primary ss-botao-adicionar",
                onClick: ($event: any) => (_ctx.adicionar(card.identificador))
              }, [
                _createVNode(_component_icone, { nome: "mais" })
              ], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ], 40, _hoisted_1),
        (_ctx.UtilitarioGeral.validaLista(card.filhos))
          ? (_openBlock(), _createBlock(_component_fluxo, {
              key: 0,
              "ponto-inicial": false,
              editavel: _ctx.props.editavel,
              cards: card.filhos,
              onSelecaoAlterada: _ctx.selecaoCardAlterada,
              onAdicionar: _ctx.adicionar,
              onEditar: _ctx.editar,
              onExcluir: _ctx.excluir
            }, null, 8, ["editavel", "cards", "onSelecaoAlterada", "onAdicionar", "onEditar", "onExcluir"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 2))
}